import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import {
  FrequentlyBoughtTogetherContext,
  FrequentlyBoughtTogetherProvider
} from './contexts/FrequentlyBoughtTogetherContext';
// eslint-disable-next-line import/no-cycle
import LegacyFBT from './components/Legacy/Legacy.component';
import Bundle from './components/Bundle/Bundle';
import ApplianceBundle from './components/Bundle/ApplianceBundle';
import AnchorItem from './components/AnchorItem';
import Buybox from './components/Buybox/Buybox';
import * as analytics from './analytics/frequentlyboughttogether-analytics';
import { dataModel } from './dataModel';
import './frequently-bought-together.style.scss';

/* checks if the promo is within its date range,
start and end will be passed as UTC strings */
export function activePromo(start, end) {
  if (start === null || end === null) return false;
  const startArray = start.split('.');
  const endArray = end.split('.');
  const startDate = new Date(startArray[0].replace(/-/g, '/'));
  const endDate = new Date(endArray[0].replace(/-/g, '/'));
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return false;
  const currentDate = new Date();
  return currentDate >= startDate && currentDate < endDate;
}

const NRTimer = ({ startTime }) => {
  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      const endTime = new Date();
      LIFE_CYCLE_EVENT_BUS.trigger('performance.component-load', {
        componentName: 'FBT',
        startTime,
        endTime: endTime.getTime()
      });
    }
  }, []);
  return null;
};

class FrequentlyBoughtTogether extends Component {
  // eslint-disable-next-line react/static-property-placement
  static contextType = ExperienceContext;

  // sub-components
  static AnchorItem = AnchorItem;

  static Bundle = Bundle;

  static ApplianceBundle = ApplianceBundle;

  static Buybox = Buybox;

  static getCartUrl = () => {
    return '/mcc-cart/v2/Cart/';
  };

  // TODO: this is not called, safe to remove?
  static fetchCartAPIResponse = () => {
    return new Promise((resolve) => {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('global.thd-cart-loaded', () => {
        window.THDCart.getCartData()
          .then(resolve)
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            resolve(null);
          });
      });
    });
  };

  static getFinalPriceMessageCount = (checkedItems = []) => {
    return checkedItems.filter(
      (item) => (item?.pricing?.mapScenario || item?.pricing?.message === 'see final price in cart')
    ).length;
  };

  static getTotalPrice = (items = []) => {
    const checkedItems = items.filter((item) => item.checked);
    const hidePromotionDetails = checkedItems.some((item) => !item?.pricing?.original);
    let originalPriceTotal = '';
    let dollarOffTotal = '';
    let percentageOffTotal = '';

    if (!hidePromotionDetails) {
      // originalPrice total
      originalPriceTotal = checkedItems.reduce((acc, item) => {
        return acc + (item?.pricing?.original || item?.pricing?.value);
      }, 0);
      originalPriceTotal = parseFloat(originalPriceTotal.toFixed(2));
      // dollarOff total
      dollarOffTotal = checkedItems.reduce((acc, item) => {
        const dollarOff = item?.pricing?.promotion?.dollarOff
          ? item?.pricing?.promotion?.dollarOff
          : 0;
        return acc + dollarOff;
      }, 0);
      dollarOffTotal = parseFloat(dollarOffTotal.toFixed(2));
      // percentageOff total
      percentageOffTotal = originalPriceTotal === 0
        ? 100
        : (dollarOffTotal / originalPriceTotal) * 100;
      percentageOffTotal = percentageOffTotal.toFixed();
    }

    // specialPrice total
    let valuePriceTotal = checkedItems.reduce((acc, item) => {
      return acc + item?.pricing?.value;
    }, 0);
    valuePriceTotal = parseFloat(valuePriceTotal.toFixed(2));
    // pricingMessage
    let pricingMessage = checkedItems.reduce((acc, item) => {
      if (item?.pricing?.message) {
        return item?.pricing?.message;
      }
      return acc;
    }, '');
    const seeFinalPriceMsgCount = this.getFinalPriceMessageCount(checkedItems);
    if (seeFinalPriceMsgCount > 0) {
      pricingMessage = 'see final price in cart';
    }

    return {
      pricing: {
        original: originalPriceTotal,
        promotion: {
          dollarOff: dollarOffTotal,
          percentageOff: percentageOffTotal,
        },
        value: valuePriceTotal,
        message: pricingMessage,
        mapAboveOriginalPrice: this.getMapAboveOriginal(items)
      }
    };
  };

  static getMapAboveOriginal = (items = []) => {
    let mapAboveOriginalPrice = false;
    items.map((item) => {
      if (!item.checked) return mapAboveOriginalPrice;
      if (item.pricingMessage === 'see final price in cart' && item.mapAboveOriginalPrice) {
        mapAboveOriginalPrice = true;
      }
      return mapAboveOriginalPrice;
    });
    return mapAboveOriginalPrice;
  };

  constructor(props) {
    super(props);
    this.startTime = new Date().getTime();
  }

  state = {
    itemInCart: false,
    // eslint-disable-next-line react/destructuring-assignment
    checkedItems: [this.props.itemId], // this is the ui state
    // eslint-disable-next-line react/no-unused-state
    products: [], // this is the data
    // eslint-disable-next-line react/no-unused-state
    product: null
  };

  getCart(items) {
    const directCheckout = items.every((item) => item.product?.identifiers?.productType !== 'MAJOR_APPLIANCE');
    const { channel } = this.context;
    const options = {
      host: typeof window !== 'undefined'
        ? window.location.origin
        : null,
      channel,
      paypal: false,
      misship: false,
      directCheckout
    };
    const zipCode = typeof window !== 'undefined' ? window.cookieUtils?.readBrowserCookie?.('THD_AOL') : '';
    const itemDetails = items.filter((item) => item.checked)
      .map((item) => {
        const isMajorApplianceItem = item.product?.identifiers?.productType === 'MAJOR_APPLIANCE';
        if (isMajorApplianceItem) {
          return {
            itemId: String(item.itemId),
            quantity: 1,
            fulfillmentMethod: 'DirectDelivery',
            fulfillmentLocation: zipCode || '',
          };
        }
        return {
          itemId: String(item.itemId),
          quantity: 1
        };
      });
    return {
      itemDetails,
      options
    };
  }

  onAddToCartClick = (products, promo, bundle = false) => {
    const { checkedItems } = this.state;
    const { itemId } = this.props;
    let analyticsItems = [];
    products.forEach((product) => {
      if (checkedItems) {
        if (product.itemId !== itemId || bundle) {
          analyticsItems.push(product);
        }
      }
      if (!promo && !bundle) {
        this.onChangeCheckbox(product.itemId);
      }
    });
    analytics.fbtAddToCartAnalytics({ analyticsItems, bundle });
  };

  onChangeCheckbox = (id) => {
    const { checkedItems } = this.state;
    const index = checkedItems.indexOf(id);
    let copy = checkedItems.slice();
    if (index > -1) {
      copy.splice(index, 1);
    } else {
      copy.push(id);
    }
    this.setState({ checkedItems: copy });
  };

  getImageURL = (images) => {
    if (!images || images.length === 0) return null;
    const primary = images.find((img) => img.subType === 'PRIMARY');
    if (!primary) return null;
    return primary.url;
  };

  setPrimary = (sku) => {
    return { ...sku, type: 'primary' };
  };

  getPriceMessage = (selectedItemsCount, priceMsgCount) => {
    const message = {};
    if (selectedItemsCount === 1) {
      message.priceMessage = 'Price:';
    } else if (selectedItemsCount === 2) {
      message.priceMessage = 'Price for both:';
    } else if (selectedItemsCount === 3) {
      message.priceMessage = 'Price for all three:';
    } else if (selectedItemsCount === 4) {
      message.priceMessage = 'Price for all four:';
    } else if (selectedItemsCount === 5) {
      message.priceMessage = 'Price for all five:';
    } else if (selectedItemsCount === 0) {
      message.priceMessage = '';
    }
    if (priceMsgCount > 0) message.priceMessage = '';
    return message;
  };

  handleProductchange = ({ data }) => {
    if (data) {
      const { product } = data;
      const { itemId } = product.identifiers;
      this.setState({ checkedItems: [itemId] });
    }
  };

  parseProductResponse = ({ data } = {}) => {
    if (data) {
      const { product } = data;
      return product;
    }
    return null;
  };

  shouldShowBundle = (products, type) => {
    return type === 'APPLIANCE_BUNDLE' || activePromo(products[0].idStartDate, products[0].idEndDate);
  };

  handleDynamicRecsLoad = (resp) => {
    const type = resp?.data?.bundle?.metadata?.type;
    const products = resp?.data?.bundle?.products;
    const { itemId, onLoadDynamicRecs } = this.props;
    if (products?.length) {
      const additionalIds = type === 'APPLIANCE_BUNDLE' ? (products
        .filter((item) => !item.isAnchor)
        .map(({ product }) => product?.identifiers?.itemId)).slice(0, 1) : (products
        .map(({ product }) => product?.identifiers?.itemId)
        .filter((val) => val));

      this.setState((state) => ({
        ...state,
        checkedItems: [itemId, ...additionalIds]
      }));
    }
    if (onLoadDynamicRecs) {
      onLoadDynamicRecs(resp);
    }
  };

  updateCheckedItems = (currentItem, newItem) => {
    const { checkedItems } = this.state;
    const newCheckedItems = checkedItems.filter((item) => item !== currentItem);
    newCheckedItems.push(newItem);
    this.setState({ checkedItems: newCheckedItems });
  }

  // TODO: this is not called, safe to remove?
  async isPrimaryInCart(product) {
    const { itemId } = product.identifiers;
    try {
      const cartResponse = await FrequentlyBoughtTogether.fetchCartAPIResponse();
      if (cartResponse) {
        const { CartModel = {} } = cartResponse;
        const { itemModels = [] } = CartModel;
        const itemInCart = itemModels.findIndex((item) => item.itemId === itemId) > -1;
        this.setState({
          itemInCart
        });
      }
    } catch (event) {
      // eslint-disable-next-line no-console
      console.error(event);
    }
  }

  normalizeSkus({ products }) {
    const { checkedItems } = this.state;
    return products.map((product, productIndex) => {
      // primary item is a frontEnd model response
      const {
        idStartDate,
        idEndDate,
        idPromoDetails,
        category,
        description,
        isAnchor,
        product: {
          identifiers: {
            canonicalUrl: canonicalURL,
            itemId,
            brandName,
            productLabel
          },
          pricing,
          media: {
            images
          },
          reviews
        }
      } = product;

      const averageRating = reviews?.ratingsReviews?.averageRating;
      const totalReviews = reviews?.ratingsReviews?.totalReviews;

      // ssr should check the first item
      const checked = typeof window === 'undefined' && productIndex === 0
        ? true
        : (checkedItems.indexOf(itemId) > -1);

      if (productIndex === 0) {
        const image = images.find((i) => i.subType === 'PRIMARY');
        const imageURL = image ? image.url : '';
        return {
          brand: brandName,
          canonicalURL,
          pricing,
          idStartDate,
          idEndDate,
          idPromoDetails,
          category,
          itemId,
          productName: productLabel,
          rating: averageRating,
          reviews: totalReviews,
          imageURL,
          checked,
          product: product.product,
          type: 'primary'
        };
      }
      return {
        brand: brandName,
        canonicalURL,
        pricing,
        productName: productLabel,
        rating: averageRating,
        reviews: totalReviews,
        imageURL: this.getImageURL(images),
        itemId,
        idPromoDetails,
        category,
        description,
        isAnchor,
        checked,
        product: product.product,
        type: 'product'
      };
    });
  }

  render() {
    const {
      itemId,
      openInNewTab,
      storeId
    } = this.props;

    const { channel } = this.context;
    const { itemInCart, checkedItems = [] } = this.state;

    return (
      <FrequentlyBoughtTogetherProvider storeId={storeId} itemId={itemId} onChange={this.handleDynamicRecsLoad}>
        <FrequentlyBoughtTogetherContext.Consumer>
          {({
            bundleResponseData,
            storeId: loadedStoreId,
            isFulfillable,
            isDisplayableBasedOnFulfillment,
            productResponseData,
            bundleType,
            isApplianceBundle,
            isPromotionalBundle
          }) => {

            const product = productResponseData?.product;
            if (!product) return null;

            const bundleProducts = bundleResponseData?.bundle?.products;
            if (!bundleProducts?.length) return null;

            if (!isApplianceBundle && !isFulfillable) return null;
            if (!isApplianceBundle && !isDisplayableBasedOnFulfillment) return null;

            const bundleHeading = isApplianceBundle ? bundleProducts[0].slot.description : '';
            let bundleItemTitle = '';
            let anchorItemTitle = '';
            if (isApplianceBundle) {
              bundleProducts.forEach((item) => {
                if (item.isAnchor) {
                  anchorItemTitle = item.category;
                } else {
                  bundleItemTitle = item.category;
                }
              });
            }
            const productsToNormalize = isApplianceBundle
              ? bundleProducts.filter((item) => !item.isAnchor)
              : bundleProducts;
            const normalizedProducts = this.normalizeSkus({ products: [{ product }, ...productsToNormalize] });

            const cart = this.getCart(normalizedProducts);
            const priceMsgCount = FrequentlyBoughtTogether.getFinalPriceMessageCount(bundleProducts);
            const message = this.getPriceMessage(checkedItems.length, priceMsgCount);
            const displayPromoBundle = this.shouldShowBundle(bundleProducts, bundleType);

            let totalPrice = {};
            if (checkedItems.length) {
              totalPrice = FrequentlyBoughtTogether.getTotalPrice(normalizedProducts);
            }

            if (!displayPromoBundle) {
              return (
                <>
                  <NRTimer startTime={this.startTime} />
                  <LegacyFBT
                    itemId={itemId}
                    onChangeCheckbox={this.onChangeCheckbox}
                    product={product}
                    products={normalizedProducts}
                    storeId={loadedStoreId}
                  />
                </>
              );
            }
            if (bundleType === 'PROMO_BUN') {
              return (
                displayPromoBundle && (
                  <>
                    <NRTimer startTime={this.startTime} />
                    <Bundle
                      cartOptions={cart.options}
                      cartReqParams={cart.itemDetails}
                      channel={channel}
                      itemId={itemId}
                      itemInCart={itemInCart}
                      message={message}
                      openInNewTab={openInNewTab}
                      onAddToCartClick={() => this.onAddToCartClick(normalizedProducts,
                        isPromotionalBundle,
                        isApplianceBundle)}
                      pricing={totalPrice}
                      product={product}
                      products={normalizedProducts}
                      storeId={loadedStoreId}
                    />
                  </>
                )
              );
            }
            return (
              isApplianceBundle && displayPromoBundle && (
                <ApplianceBundle
                  bundleHeading={bundleHeading}
                  anchorItemTitle={anchorItemTitle}
                  bundleItemTitle={bundleItemTitle}
                  cartOptions={cart.options}
                  cartReqParams={cart.itemDetails}
                  channel={channel}
                  itemId={itemId}
                  itemInCart={itemInCart}
                  message={message}
                  onAddToCartClick={() => this.onAddToCartClick(normalizedProducts,
                    isPromotionalBundle,
                    isApplianceBundle)}
                  openInNewTab={openInNewTab}
                  updateCheckedItems={this.updateCheckedItems}
                  pricing={totalPrice}
                  product={product}
                  products={normalizedProducts}
                  checkedItems={checkedItems}
                  storeId={loadedStoreId}
                />
              )
            );
          }}
        </FrequentlyBoughtTogetherContext.Consumer>
      </FrequentlyBoughtTogetherProvider>
    );
  }
}

FrequentlyBoughtTogether.displayName = 'FrequentlyBoughtTogether';

FrequentlyBoughtTogether.propTypes = {
  itemId: PropTypes.string.isRequired,
  openInNewTab: PropTypes.bool,
  storeId: PropTypes.string,
  onLoadDynamicRecs: PropTypes.func
};

FrequentlyBoughtTogether.defaultProps = {
  openInNewTab: false,
  storeId: null,
  onLoadDynamicRecs: null
};

FrequentlyBoughtTogether.dataModel = dataModel;

export default FrequentlyBoughtTogether;
